import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=7c894abb"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports